import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import ContactEmerald from '../components/Contact/ContactEmerald'

const Contactpage = () => {
    return (
        <div>

        <Navbar/>
        <ContactEmerald/>



        <Footer/>

        </div>
    )
}

export default Contactpage